import { IonApp } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { lazy, Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PageLoader } from "@/components/States";

const ConsultantPage = lazy(() => import("@/pages/ConsultantPage").then((module) => ({ default: module.ConsultantPage })));
const GroupChatPage = lazy(() => import("@/pages/GroupChatPage").then((module) => ({ default: module.GroupChatPage })));
const GroupsPage = lazy(() => import("@/pages/GroupsPage").then((module) => ({ default: module.GroupsPage })));
const ListingDetailPage = lazy(() => import("@/pages/ListingDetailPage").then((module) => ({ default: module.ListingDetailPage })));
const LoginPage = lazy(() => import("@/pages/LoginPage").then((module) => ({ default: module.LoginPage })));
const MarketplacePage = lazy(() => import("@/pages/MarketplacePage").then((module) => ({ default: module.MarketplacePage })));
const NotFoundPage = lazy(() => import("@/pages/NotFoundPage").then((module) => ({ default: module.NotFoundPage })));
const PostPage = lazy(() => import("@/pages/PostPage").then((module) => ({ default: module.PostPage })));
const ProfilePage = lazy(() => import("@/pages/ProfilePage").then((module) => ({ default: module.ProfilePage })));
const PrivacyPage = lazy(() => import("@/pages/PrivacyPage").then((module) => ({ default: module.PrivacyPage })));
const AccountDeletionPage = lazy(() => import("@/pages/AccountDeletionPage").then((module) => ({ default: module.AccountDeletionPage })));

function PrivateRoute({ component: Component, ...rest }: { component: React.ComponentType; path: string; exact?: boolean }) {
  const { session } = useAuth();
  return <Route {...rest} render={() => session ? <Component /> : <Redirect to="/login" />} />;
}

export default function App() {
  return <IonApp><IonReactRouter><AuthProvider><Suspense fallback={<PageLoader label="စိုက်မွေးမိတ်ဆွေကို ဖွင့်နေပါသည်…" />}><Switch>
    <Route exact path="/login" component={LoginPage} />
    <Route exact path="/privacy" component={PrivacyPage} />
    <Route exact path="/account-deletion" component={AccountDeletionPage} />
    <PrivateRoute exact path="/post" component={PostPage} />
    <PrivateRoute exact path="/marketplace" component={MarketplacePage} />
    <PrivateRoute exact path="/marketplace/:id" component={ListingDetailPage} />
    <PrivateRoute exact path="/farmer-consultant" component={ConsultantPage} />
    <PrivateRoute exact path="/farmer-chat-group" component={GroupsPage} />
    <PrivateRoute exact path="/farmer-chat-group/:id" component={GroupChatPage} />
    <PrivateRoute exact path="/profile" component={ProfilePage} />
    <Route exact path="/"><Redirect to="/post" /></Route>
    <Route component={NotFoundPage} />
  </Switch></Suspense></AuthProvider></IonReactRouter></IonApp>;
}
